import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MprcButton } from "components";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCardContext } from "../../CardBuilder";
import { EditPublicationFactory } from "./EditPublicationFactory";
import { faPenCircle } from "@fortawesome/pro-regular-svg-icons/faPenCircle";

///
export const EditButton = () => {

    const { t } = useTranslation("knowledge");
    const { pub: { publicationId, publicationType, masterPublication, title }, onReload } = useCardContext();
    const [dialog, setDialog] = useState<React.ReactNode | null>(null);

    const doEdit = useCallback(() => {
        setDialog(<EditPublicationFactory
            publicationId={publicationId}
            publicationType={publicationType}
            masterPublicationId={masterPublication?.publicationId}
            masterTitle={title}
            onClose={(success) => { setDialog(null); if (success) onReload(); }}
        />);
    }, []);

    return (
        <>
            {dialog}
            <MprcButton startIcon={<FontAwesomeIcon icon={faPenCircle} fixedWidth />} color="warning" onClick={doEdit}>
                {t("Feed.Card.Common.EditButtonText")}
            </MprcButton>
        </>
    );
}
